"use client"

import React from 'react'

type BackgroundLottieProps = {
    url: string
    opacity?: number
}

export default function BackgroundLottie({ url, opacity = 1 }: BackgroundLottieProps) {
    if (!url) return null

    return (
        <div
            className="absolute inset-0 pointer-events-none overflow-hidden z-[-1] w-full h-full"
            style={{ opacity }}
        >
            <iframe
                src={url}
                title="Background Lottie Animation"
                aria-hidden="true"
                loading="lazy"
                className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 block border-none"
                style={{
                    backgroundColor: 'transparent',
                    width: '100vw',  // Force viewport width
                    height: '100vw', // Force square aspect ratio (giant box) to ensure content fills width
                    maxWidth: 'none',
                    maxHeight: 'none',
                }}
            />
        </div>
    )
}
